var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('edit-frame',{ref:"editFrame",staticClass:"reminder-frame",attrs:{"title":"Zeitversatz Erinnerungsemail","icon":"mdi-email-fast-outline","width":"850px","hideControls":true,"isEditing":_vm.isEditing},on:{"save":_vm.onSave,"cancel":_vm.onCancel,"update:isEditing":function($event){_vm.isEditing=$event},"update:is-editing":function($event){_vm.isEditing=$event}}},[_c('edit-action-buttons',{attrs:{"isEditing":_vm.isEditing,"editRef":_vm.$refs.editFrame,"inline":true},on:{"update:isEditing":function($event){_vm.isEditing=$event},"update:is-editing":function($event){_vm.isEditing=$event}}}),_c('v-text-field',{attrs:{"required":"","type":"number","rules":[
      _vm.$validation.vuetify.single({
        presence: { message: 'Pflichtfeld' },
        numericality: {
          onlyInteger: true,
          greaterThanOrEqualTo: 0,
          lessThanOrEqualTo: 1440,
          message: 'Bitte eine ganze Zahl zwischen 0 und 1440 eingeben',
        },
      }),
      (v) => v > _vm.secondReminderM || 'muss vor zweiter Erinnerung liegen',
    ],"label":"Erste Erinnerung (Minuten vor Buchungsende)","outlined":"","dense":"","disabled":!_vm.isEditing},model:{value:(_vm.firstReminderM),callback:function ($$v) {_vm.firstReminderM=_vm._n($$v)},expression:"firstReminderM"}}),_c('v-text-field',{attrs:{"required":"","type":"number","rules":[
      _vm.$validation.vuetify.single({
        presence: { message: 'Pflichtfeld' },
        numericality: {
          onlyInteger: true,
          greaterThanOrEqualTo: 0,
          lessThanOrEqualTo: 10080,
          message: 'Bitte eine ganze Zahl zwischen 0 und 10080 eingeben',
        },
      }),
      (v) => v < _vm.firstReminderM || 'muss nach erster Erinnerung liegen',
    ],"label":"Zweite Erinnerung (Minuten vor Buchungsende)","outlined":"","dense":"","disabled":!_vm.isEditing},model:{value:(_vm.secondReminderM),callback:function ($$v) {_vm.secondReminderM=_vm._n($$v)},expression:"secondReminderM"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }